var map = {
	"./1.jpeg": 772,
	"./10.jpeg": 4740,
	"./12.jpeg": 8536,
	"./13.jpeg": 6188,
	"./2.jpeg": 7264,
	"./4.jpeg": 6256,
	"./5.jpeg": 4296,
	"./6.jpeg": 5028,
	"./7.jpeg": 2244,
	"./8.jpeg": 448,
	"./9.jpeg": 6984
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 356;